// extracted by mini-css-extract-plugin
module.exports = {"container":"stats_container__X30Hc","text":"stats_text__S8PcT","bold":"stats_bold__EOBcP"};